export default __webpack_public_path__ + "static/media/UniqueFriedRicewithMasalaFriedChicken.f56f1ae5.png";